import { SNOWPLOW_TRACKING_LOG_LEVEL, snowPlowTrackingHandler } from '@/utils/snowplowTracking';

let attempt = 0;
let startTime = 0;
let endTime = 0;

/**
 * Initializes the LexisNexis ThreatMetrix device profiling
 * Note: The naming in this file is intentionally vague to not give away that this is related to fraud detection to prevent blocking
 * @param lnProfile
 */
export function setupLnProfile(lnProfile) {
  const zfp = window['_zfp'];
  if (typeof zfp === 'undefined' || typeof zfp.init === 'undefined' || zfp['inited']) return;
  if (!lnProfile || !lnProfile.domain || !lnProfile.orgId || !lnProfile.sessionId) return;

  try {
    startTime = performance && performance.now();
    zfp.init(lnProfile.domain, lnProfile.orgId, lnProfile.sessionId);
    attempt++;
    track('init', lnProfile.sessionId);
    initRetry(lnProfile);
  } catch (e) {
    console.error('_zpf error', e);
  }
}

function track(status, desc, addExecTime = false) {
  if (!window.$config('lnEnableLogging', false)) return;

  const execTime = addExecTime ? `, execTime: ${endTime - startTime}` : ''

  snowPlowTrackingHandler.sendLog({
    logLevel: SNOWPLOW_TRACKING_LOG_LEVEL.INFO,
    message: `status: ${status}, sessionId: ${desc}, attempt: ${attempt} ${execTime}`,
    name: 'lnprofile',
  });
}

function initRetry(lnProfile) {
  // callback from LexisNexis side
  window.tmx_profiling_complete = (sessionId) => profilingComplete(sessionId, lnProfile);

  if (!window.$config('lnEnableRetry', false) || window['_zfp']['inited']) {
    window['_zfp']['inited'] = true;
    return;
  }

  if (attempt >= 3) {
    window['_zfp']['inited'] = true;
    track('incomplete', lnProfile.sessionId);
    return;
  }

  // retry when callback not triggered
  setTimeout(function () {
    setupLnProfile(lnProfile)
  }, 10000);
}

function profilingComplete(sessionId, lnProfile) {
  endTime = performance && performance.now();
  window['_zfp']['inited'] = true;
  const status = sessionId === lnProfile.sessionId ? 'complete' : 'mismatch';
  track(status, `${sessionId}:${lnProfile.sessionId}`, true);
}
